import React from 'react';
import InputField from '../../../../../../component/form/FormInput';
import { getCurrentDate } from '../../../../../../utils/dateUtils';

export default function GSTSettings({
	setIsGstRegEnable,
	isGstRegEnable,
	gstForm,
	error,
	setError,
	setGSTForm,
	setIsEdit,
	handleFormData,
}) {
	return (
		<div className="p-3">
			<div className="d-flex align-items-center py-3 gap-4">
				<div className="col-3 col-xl-2 fs-5 fw-semibold text-dark">GST Registration Enable</div>
				<div className="form-check">
					<input
						class="form-check-input"
						type="checkbox"
						checked={isGstRegEnable}
						id="flexCheckDefault"
						onChange={(e) => setIsGstRegEnable(!isGstRegEnable)}
					/>
				</div>
			</div>
			{isGstRegEnable && (
				<div>
					<div className="d-flex align-items-center py-3">
						<div className="col-3 col-xl-2 fs-5 fw-semibold text-dark">GSTIN</div>
						<div className="col-8 col-xl-4 align-items-center">
							<InputField
								label=""
								autoComplete="off"
								placeholder="GSTIN Number"
								value={gstForm.gstin}
								onChange={(value) => handleFormData('gstin', value, true)}
								type="text"
								disabled={false}
								error={error?.gstin}
							/>
							{/* <InputField
								label=""
								placeholder="GSTIN Number"
								type="text"
								autoComplete="off"
								value={gstForm.gstin}
								onChange={(value) => handleFormData('gstin', value, true)}
								error={error?.gstin}
								showValidateIcon={true}
							/> */}
						</div>
					</div>
					<div className="d-flex align-items-center py-3">
						<div className="col-3 col-xl-2 fs-5 fw-semibold text-dark">Business Legal Name</div>
						<div className="col-8 col-xl-4">
							<InputField
								label=""
								placeholder="Business Legal Name"
								type="text"
								required={false}
								value={gstForm.business_legal_name}
								onChange={(value) => handleFormData('business_legal_name', value, true)}
								error={error?.business_legal_name}
							/>
						</div>
					</div>
					<div className="d-flex align-items-center py-3">
						<div className="col-3 col-xl-2 fs-5 fw-semibold text-dark">Business Trade Name</div>
						<div className="col-8 col-xl-4">
							<InputField
								label=""
								placeholder="Business Trade Name"
								type="text"
								required={false}
								value={gstForm.business_trade_name}
								onChange={(value) => handleFormData('business_trade_name', value, true)}
								error={error?.business_trade_name}
							/>
						</div>
					</div>
					<div className="d-flex align-items-center py-3">
						<div className="col-3 col-xl-2 fs-5 fw-semibold text-dark">GST Registration Date</div>
						<div className="col-8 col-xl-4">
							<InputField
								label=""
								placeholder="GST Registration Date"
								type="date"
								required={false}
								value={gstForm.gst_registration_date}
								onBlur={(e) => {
									var value = e.target.value;
									const newError = { ...error };
									var date = new Date(value);
									var currentDate = new Date();
									currentDate.setDate(currentDate.getDate() + 1);
									let year = date.getFullYear().toString();
									if (year.length === 4 && new Date(value) > currentDate.setHours(0, 0, 0, 0)) {
										newError.gst_registration_date = 'Date cannot be in the future';
										setError(newError);
										setGSTForm((prev) => ({
											...prev,
											gst_registration_date: value,
										}));
									} else {
										setGSTForm((prev) => ({
											...prev,
											gst_registration_date: value,
										}));
										delete newError.gst_registration_date;
										setError(newError);
									}
									// setIsEdit(true);
								}}
								onChange={(value) => {
									const newError = { ...error };
									var date = new Date(value);
									var currentDate = new Date();
									currentDate.setDate(currentDate.getDate() + 1);
									let year = date.getFullYear().toString();
									if (year.length === 4 && new Date(value) > currentDate.setHours(0, 0, 0, 0)) {
										newError.gst_registration_date = 'Date cannot be in the future';
										setError(newError);
										setGSTForm((prev) => ({
											...prev,
											gst_registration_date: value,
										}));
									} else {
										setGSTForm((prev) => ({
											...prev,
											gst_registration_date: value,
										}));
										delete newError.gst_registration_date;
										setError(newError);
									}
									// setIsEdit(true);
								}}
								error={error?.gst_registration_date}
								max={getCurrentDate()}
							/>
						</div>
					</div>
					<div className="d-flex align-items-center py-3">
						<div className="col-3 col-xl-2 fs-5 fw-semibold text-dark">Composition <br className='d-xl-none d-block' /> Enable</div>
						<div className="form-check">
							<input
								class="form-check-input"
								type="checkbox"
								checked={gstForm.composition_enable}
								id="flexCheckDefault"
								onChange={(e) => handleFormData('composition_enable', !gstForm.composition_enable)}
							/>
						</div>
					</div>
					<div className="d-flex align-items-center py-3">
						<div className="col-3 col-xl-2 fs-5 fw-semibold text-dark">Composition Scheme</div>
						<div className="form-check">
							<input
								class="form-check-input"
								type="checkbox"
								checked={gstForm.composition_scheme}
								id="flexCheckDefault"
								onChange={(e) => handleFormData('composition_scheme', !gstForm.composition_scheme)}
							/>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
